export const requestsConstants = {
    CLOSE_FILTER: 'REQUESTS_CLOSE_FILTER',
    HISTORY_OPEN: 'REQUESTS_HISTORY_OPEN',
    HISTORY_CLOSE: 'REQUESTS_HISTORY_CLOSE',
    MAP_OPEN: 'REQUESTS_MAP_OPEN',
    MAP_CLOSE: 'REQUESTS_MAP_CLOSE',
    CLOSE_REPORT: 'CLOSE_REPORT',
    FETCH_REQUESTS: 'FETCH_REQUESTS',
    FETCH_EXPIRED_REQUESTS: 'FETCH_EXPIRED_REQUESTS',
    SET_REPORTS: 'SET_REPORTS',
    SET_REPORT: 'SET_REPORT',
    SET_CREATION_METHODS: 'SET_CREATION_METHODS',
    SET_SUBSERVICE_VALUE: 'SET_SUBSERVICE_FILTER_VALUE', 
    SEARCH_REQUEST_BY_NUMBER: 'SEARCH_REQUEST_BY_NUMBER',
    UNSET_RESORT: 'UNSET_RESORT',
    POST_ERROR: 'POST_ERROR',
    SET_REQUEST_RATING: 'SET_REQUEST_RATING',
    SET_REQUEST_STATUS: 'SET_REQUEST_STATUS',
    SET_REQUEST_EXECUTE_TIME: 'SET_REQUEST_EXECUTE_TIME',
    SET_REQUEST_INVOICE: 'SET_REQUEST_INVOICE',
    SET_REQUEST_EXECUTER: 'SET_REQUEST_EXECUTER',
    SET_REQUEST_MASTER: 'SET_REQUEST_MASTER',
    SET_REQUEST_SERVICE: 'SET_REQUEST_SERVICE',
    SET_REQUEST_ADDRESS: 'SET_REQUEST_ADDRESS',
    UPDATE_REQUESTS: 'UPDATE_REQUESTS',
    MARK_REQUEST_VIEWED: 'MARK_REQUEST_VIEWED',
    MARK_REQUEST_COMMENTED: 'MARK_REQUEST_COMMENTED',
    SHOW_PREVIEW: 'SHOW_PREVIEW',
    SHOW_MODAL: 'SHOW_MODAL',
    HIDE_MODAL: 'HIDE_MODAL',
    HIDE_PREVIEW: 'HIDE_PREVIEW',
    SET_PREVIEW_INDEX: 'SET_PREVIEW_INDEX',
    RETRIEVE_LAST_STATE: 'RETRIEVE_LAST_STATE',
    SET_REQUESTS_FAILED_VALUE: "SET_REQUESTS_FAILED_VALUE",
    SET_FAILED_FILE_FETCH_DATA: 'SET_FAILED_FILE_FETCH_DATA',
    SET_FAILED_FILE_FETCH_CLEAR: 'SET_FAILED_FILE_FETCH_CLEAR',
    SET_IMPORT_RESULT: 'SET_IMPORT_RESULT',
    SET_IMPORT_RESULT_REQUESTS: 'SET_IMPORT_RESULT_REQUESTS',
    SET_SHOW_MODAL_STAGE: 'SET_SHOW_MODAL_STAGE',
    SET_SHOW_MODAL_CHESS: 'SET_SHOW_MODAL_CHESS',
    SET_ACTIVE_REQUEST: 'SET_ACTIVE_REQUEST'
};
